@let historyItems = historyItems$ | async;
<div class="modal-title">Exception History</div>

<div class="exception-history-items">
  @for (item of historyItems; track item) {
    <div class="history-item">
      <div class="history-item-date">{{ item.createdAt | dateFormat }}</div>
      <div class="history-item-descr">
        <strong>{{ item.type.replace('_', ' ') | titlecase }}</strong> {{ item.newValue ? 'changed' : 'made' }} by
        <strong>{{ item.updatedBy.id | teamMemberName | async }}</strong>
      </div>
    </div>
  }
</div>

@if (!historyItems?.length) {
  <div class="empty-list-message">No Exception History yet.</div>
}

<div class="modal-buttons">
  <button rktButton title="Close" (click)="activeModal.close(true)">Close</button>
</div>
